<!-- 采销订单管理 -->
<template>
  <div class="leasecontract">
    <!-- 页面最上层tab -->
    <el-tabs v-model="allActiveName" :before-leave="beforeLeave" @tab-click="tabClick">
      <el-tab-pane
        v-for="(item, index) in allTabList"
        :key="'tabList' + index"
        :label="returnPaneLabel(item.name, item.value)"
        :name="item.state + ''"
      >
      </el-tab-pane>
    </el-tabs>
    <!-- 采购主订单tab -->
    <keep-alive>
      <div v-if="Number(allActiveName) === 0">
      <el-tabs type="card" v-model="tabName" @tab-click="changeSubTabs">
        <el-tab-pane
          v-for="(item, index) in tabsList"
          :key="'tabList' + index"
          :label="getTbas(item.name, item.value)"
          :name="item.state + ''"
          class="leasecontract_tabs_item"
        >
        </el-tab-pane>
      </el-tabs>
      <div class="whole_contract_from">
        <el-form ref="from_params" :model="params">
          <QS-search>
            <el-form-item label="采购订单ID" prop="id">
              <el-input
                v-number:integer="18"
                v-model="params.id"
                placeholder="请输入采购订单ID"
                clearable
              />
            </el-form-item>
            <el-form-item label="车源方" prop="providerId">
              <el-select
                v-model="params.providerId"
                filterable
                clearable
                placeholder="请选择车源方"
              >
                <el-option label="全部" value=""></el-option>
                <el-option
                  v-for="item in carProviderList"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="订单创建时间" prop="startTime">
              <el-date-picker
                v-model="params.startTime"
                type="daterange"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                start-placeholder="开始日期"
                range-separator="至"
                end-placeholder="结束日期"
                prefix-icon="el-icon-date"
              />
            </el-form-item>
            <el-form-item label="所属部门" prop="deptIdList">
              <DeptSelect v-model="params.deptIdList" :multiple="true" :isAll="false" />
            </el-form-item>
            <!-- 按钮区域-->
            <template slot="moreBtn">
              <el-form-item>
                <el-button
                  type="primary"
                  size="small"
                  class="whole_contract_btn"
                  @click="getsearch"
                  :loading="BLMloading"
                  >查询</el-button
                >
                <el-button
                  size="small"
                  class="whole_contract_btn"
                  @click="getreset"
                  >重置</el-button
                >
              </el-form-item>
              <el-form-item>
                <export
                  exportTemplate="PurchaseOrder"
                  filename="采购订单.xlsx"
                  :params="exportParams"
                />
              </el-form-item>
            </template>
          </QS-search>
        </el-form>
      </div>
      <!-- searchBox上面的按钮 开始 -->
      <div class="leasecontract_signing">
        <el-button
          type="primary"
          size="small"
          class="whole_contract_btn"
          @click="addSigning"
          v-if="judgePermission('purchase_new_order_list_create')"
          >新建采购订单</el-button
        >
        <el-button
          v-if="judgePermission('purchase_new_order_list_init')"
          type="primary"
          size="small"
          @click="initOrder"
        >
          初始化历史采购订单
        </el-button>
      </div>
      <!-- searchBox上面的按钮 结束 -->
      <QS-common-table
        :loading="BLMloading"
        :data="tableData"
        :columns="headData"
        :pagination="paginationData"
        @change="pageEvent"
      ></QS-common-table>
    </div>
    </keep-alive>
    <!-- 采购子订单列表 -->
    <div v-if="Number(allActiveName) === 1">
      <el-tabs type="card" v-model="tabName" @tab-click="BLMloading = true">
        <el-tab-pane
          v-for="(item, index) in tabsList"
          :key="'subTabList' + index"
          :label="getTbas(item.name, item.subValue)"
          :name="item.state + ''"
          class="leasecontract_tabs_item"
        >
        </el-tab-pane>
      </el-tabs>
      <sonOrderManage :state="tabName"/>
    </div>
    <dialog-wrap-upgrade ref="batchImport" :configOptions="configOptions">
      <template
        #uploadMain
        v-if="judgePermission('purchase_new_order_list_init')"
      >
        <el-upload
          class="upload-demo"
          action=""
          :http-request="({ file }) => uploadRequest(file, 41)"
          :limit="1"
          :autoUpload="true"
          :file-list="fileList"
          :show-file-list="false"
          accept=".xls,.xlsx"
        >
          <el-button size="small" type="primary">初始化主订单</el-button>
        </el-upload>
      </template>
      <template
        #uploadVice
        v-if="judgePermission('purchase_new_order_list_init')"
      >
        <el-upload
          class="upload-demo"
          action=""
          :http-request="({ file }) => uploadRequest(file, 42)"
          :limit="1"
          :autoUpload="true"
          :file-list="fileList"
          :show-file-list="false"
          accept=".xls,.xlsx"
        >
          <el-button size="small" type="primary">初始化在租子订单</el-button>
        </el-upload>
      </template>
      <template
        #uploadReturn
        v-if="judgePermission('purchase_new_order_list_init')"
      >
        <el-upload
          class="upload-demo"
          action=""
          :http-request="({ file }) => uploadRequest(file, 43)"
          :limit="1"
          :autoUpload="true"
          :file-list="fileList"
          :show-file-list="false"
          accept=".xls,.xlsx"
        >
          <el-button size="small" type="primary">初始化已退子订单</el-button>
        </el-upload>
      </template>
    </dialog-wrap-upgrade>
  </div>
</template>
<script>
import selectOptionDict from '@/store/dict/selectOptionDict'
// eslint-disable-next-line import/no-cycle
import { getCarProvider } from '@/api/domain/cars.js'
import {
  getTabCount,
  getPurchaseList,
  purchaseSubSummary,
} from '@/api/domain/purchase.js'
import { debounce, getHead } from '@/utils'
import sonOrderManage from './pages/sonOrderMange/index.vue'
import {
  entPurchaseOrderTemplate,
  entPurchaseSubOrderTemplate,
  entPurchaseReturnSubOrderTemplate,
} from '@/config'
import axios from 'axios'
import { uploadTaskCreate } from '@/api/domain/others.js'
import config from './config'

export default {
  data() {
    const { headData } = config.call(this)
    return {
      fileList: [],
      allActiveName: 0,
      allTabList: [
        { value: '', key: 'allOrderNum', state: 0, name: '采购订单' },
        { value: '', key: 'allSubOrderNum', state: 1, name: '采购子订单' },
      ],
      // 车源方
      carProviderList: [],
      BLMloading: false,
      // tab标签数据
      tabsList: [
        {
          value: '',
          subValue: '',
          key: 'totalNum',
          state: 1,
          name: '全部订单',
        },
        {
          value: '',
          subValue: '',
          key: 'processNum',
          state: 2,
          name: '进行中订单',
        },
        {
          value: '',
          subValue: '',
          key: 'closedNum',
          state: 4,
          name: '已关闭订单',
        },
      ],
      // 控制当前二级tabs高亮
      tabName: '1',
      // from表单
      params: {
        id: '', // 采购订单ID
        providerId: '', // 车源方
        startTime: '', // 开始时间
        endTime: '', // 结束时间
        deptIdList: [], // 所属部门
      },
      // 表格请求的总数据
      tableData: [],
      // 表格头部一行展示内容
      headData,
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [10, 20, 30, 50],
      },
    }
  },
  components: { sonOrderManage },
  computed: {
    // 导入功能弹框配置信息
    configOptions() {
      return {
        attrs: {
          title: '初始化历史采购订单',
          width: '1000px',
          closeOnClickModal: false,
        },
        contentConfig: {
          title:
            '此功能用于批量初始化历史「采购订单-主订单」和「采购订单-子订单」这个功能的前提是，您已经制作了一张目标表单希望直接将Excel转移到系统，请单击 下载模板 下载Excel标准模板。',
          describes: [
            '导入前准备：',
            '1.请使用标准模板，确认未进行过任何更改，若无意中修改了模版的原有内容，建议重新下载模版；',
            '2.确保Excel中数据没有任何颜色样式，否则将与导入功能的错误提示混淆；',
            '3.确保excel中数据格式正确。',
            '4.如果表单中有设置必填项字段，在Excel中对应的列下，都必须有数据/值；',
          ],
        },
        footerList: [
          { slotName: 'uploadMain' },
          {
            text: '主订单模板下载',
            isShowBtn: this.judgePermission('purchase_new_order_list_init'),
            click: () => {
              window.location.href = entPurchaseOrderTemplate
            },
            options: {},
          },
          { slotName: 'uploadVice' },
          {
            text: '在租子订单模版下载',
            isShowBtn: this.judgePermission('purchase_new_order_list_init'),
            click: () => {
              window.location.href = entPurchaseSubOrderTemplate
            },
            options: {},
          },
          { slotName: 'uploadReturn' },
          {
            text: '已退子订单模版下载',
            isShowBtn: this.judgePermission('purchase_new_order_list_init'),
            click: () => {
              window.location.href = entPurchaseReturnSubOrderTemplate
            },
            options: {},
          },
        ],
      }
    },
    // 获取查询入参
    getCollect() {
      return {
        ...this.params,
        state: Number(this.tabName) !== 1 ? Number(this.tabName) : '',
        pageNum: this.paginationData.pageNum,
        pageSize: this.paginationData.pageSize,
        createTimeStart: this.params.startTime ? this.params.startTime[0] : '',
        createTimeEnd: this.params.startTime ? this.params.startTime[1] : '',
      }
    },
    // 导出参数
    exportParams() {
      return {
        ...this.params,
        state: Number(this.tabName) !== 1 ? Number(this.tabName) : '',
        createTimeStart: this.params.startTime ? this.params.startTime[0] : '',
        createTimeEnd: this.params.startTime ? this.params.startTime[1] : '',
      }
    },
  },
  created() {
    this.getCarProvider()
    this.purchaseSummaryFn() // 采购主订单数量统计
    this.purchaseSubSummaryFn() // 采购子订单数量统计
    this.getTableData() // 请求表单数据
  },
  methods: {
    /* 自定义上传 */
    uploadRequest(file, uploadType) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('group', 'vehicle')
      formData.append('code', 'vehicle_procure_file')

      axios({
        url: '/admin/v1/vehicle/fs/standard/upload',
        method: 'POST',
        data: formData,
        headers: {
          ...getHead(this.$store),
        },
      }).then(({ data: { code, data, msg } }) => {
        if (code === 1) {
          try {
            uploadTaskCreate({
              uploadType, // 41 初始化主订单 42 初始化在租子订单 43 初始化退车子订单
              fileAddress: data,
              fileName: file.name,
            })
              .then((res) => {
                if (res.code === 1) {
                  this.$message({
                    message: '导入成功',
                    type: 'success',
                  })
                  this.$refs.batchImport.close()
                }
              })
              .catch(() => {
                this.fileList = []
              })
            this.fileList = []
          } catch (error) {
            this.fileList = []
          }
        } else {
          this.fileList = []
          this.$message.error(msg)
        }
      })
    },
    initOrder() {
      this.$refs.batchImport.showDialog()
    },
    returnPaneLabel(val, content) {
      if (content) {
        return `${val} ( ${content} ) `
      } else {
        return `${val} ( 0 ) `
      }
    },
    // eslint-disable-next-line vue/no-unused-properties
    handleOrderIdClick(id) {
      this.$router.push({
        path: '/purchaseNew/purchaseOrder/detail',
        query: { id },
      })
    },
    async getCarProvider() {
      const { code, data } = await getCarProvider({
        state: 1,
        serviceType: 0,
      })
      if (code === 1) {
        this.carProviderList = data.items
      }
    },
    // 二级tab标签显示内容
    getTbas(val, content) {
      if (content) {
        return `${val} ( ${content} ) `
      } else {
        return `${val} ( 0 ) `
      }
    },
    // 分页器的事件
    pageEvent({ pagination }) {
      this.paginationData.pageSize = pagination.pageSize
      this.paginationData.pageNum = pagination.pageNum
      this.getTableData()
    },
    // 切换子tab
    async changeSubTabs() {
      this.BLMloading = true
      this.getreset() // 重置（附带 列表查询调用）
    },
    // 搜索按钮
    getsearch: debounce(async function () {
      this.paginationData.pageSize = 10
      this.paginationData.pageNum = 1
      this.getTableData() // 列表数据
      this.purchaseSummaryFn() // 采购主订单数量统计
      this.purchaseSubSummaryFn() // 采购子订单数量统计
    }, 500),
    // 重置--清空表单项
    getreset() {
      this.paginationData.pageSize = 10
      this.paginationData.pageNum = 1
      this.$refs.from_params.resetFields() // 使表单内容重新赋值为空字符串
      this.getTableData() // 列表数据
    },
    // 新增采购单按钮点击事件
    addSigning() {
      // this.$router.push('/purchase/purchase_order_manage/purchase_order_add')
      this.$router.push('/purchaseNew/purchaseOrder/add')
    },
    // 操作列----补录车辆信息
    // eslint-disable-next-line vue/no-unused-properties
    addCarsOperation(row) {
      const mixObj = {
        customerName:
          this.carProviderList.find((item) => item.id === row.providerId)?.name ||
          row.providerId,
        purchaseModeName:
          selectOptionDict.purchaseTypeDict[row.purchaseMode] || '',
        carTotalNum: row.carTotalNum,
        ...row,
      }
      this.$router.push({
        // path: '/purchase/purchase_order_manage/purchase_car_add',
        path: '/purchaseNew/purchaseOrder/add/addCar',
        query: {
          mixInfo: JSON.stringify(mixObj),
        },
      })
    },
    // 操作列----批量退车
    // eslint-disable-next-line vue/no-unused-properties
    returnCarOperation(row) {
      this.$router.push({
        // path: '/purchase/purchase_manage/purchase_order_manage/batchExitCar',
        path: '/purchaseNew/purchaseOrder/list/batchExitCar',
        query: {
          id: row.id,
        },
      })
    },
    // 订单关闭点击事件
    // eslint-disable-next-line vue/no-unused-properties
    getVoidComplete(item) {
      this.$router.push({
        // path: '/purchase/purchase_order_manage/purchase_order_close',
        path: '/purchaseNew/purchaseOrder/list/orderClose',
        query: { id: item.id },
      })
    },
    // 采购主订单数量统计
    async purchaseSummaryFn() {
      const { code, data } = await getTabCount({})
      if (code === 1) {
        this.tabsList.forEach((item) => {
          item.value = data[item.key]
        })
        this.allTabList.forEach((item) => {
          if (item.key === 'allOrderNum') {
            item.value = data.totalNum
          }
        })
      }
    },
    // 采购子订单数量统计
    async purchaseSubSummaryFn() {
      const { code, data } = await purchaseSubSummary()
      if (code === 1) {
        this.tabsList.forEach((item) => {
          item.subValue = data[item.key]
        })
        this.allTabList.forEach((item) => {
          if (item.key === 'allSubOrderNum') {
            item.value = data.totalNum
          }
        })
      }
    },
    // 请求数据table
    async getTableData() {
      this.BLMloading = true
      const { code, data } = await getPurchaseList(this.getCollect)
      if (code === 1) {
        this.BLMloading = false
        this.tableData = data.items
        this.paginationData.total = data.totalNum
      }
    },
    beforeLeave(activeName) {
      // 进入采购子订单tab前先清空采购订单的筛选项
      if (Number(activeName) === 1) {
        this.$refs.from_params.resetFields()
      }
      return true
    },
    tabClick() {
      if (Number(this.allActiveName) === 0) {
        this.getTableData()
      }
      this.tabName = '1'
    },
  },
}
</script>

<style lang="scss" scoped>
.leasecontract {
  ::v-deep .el-tabs__item {
    max-width: 140px;
    text-align: center;
  }

  .whole_contract_btn {
    &:nth-of-type(2) {
      color: #323233;
    }
  }

  .whole_contract_ex {
    margin-left: 8px;
  }

  .leasecontract_signing {
    margin: 16px 0;
  }

  .hand {
    user-select: none;

    span {
      cursor: pointer;
    }
  }
}
</style>
